import * as React from 'react';
import Radio from '../../Components/Radio';
import Row from '../../Components/Row';
import {
  IbanPaymentDetails,
  DefaultIbanBankAccountDetails
} from '../../Types/Payments/IbanPaymentDetails';
import { CardPaymentDetails, DefaultCreditCardPaymentDetails } from '../../Types/Payments/PaymentDetails';
import {
  IDebitCardDetails,
  DefaultIDebitCardDetails
} from '../../Types/Payments/IDebitCardDetails';
import Member from '../Types/Member';
import IbanPaymentForm from './PaymentForms/IbanPaymentForm';
import CreditCardPaymentForm from './PaymentForms/CreditCardPaymentForm';
import DirectDebitPaymentForm from './PaymentForms/DirectDebitPaymentForm';

require('../../css/membership-signup-payment.css');
require('../../css/membership-signup-giftaid.css');

enum PaymentTabs {
  DirectDebit,
  CreditCard,
  PayPal,
  BankAccount
}

type PaymentDetails = IDebitCardDetails | CardPaymentDetails | IbanPaymentDetails;

interface Props {
  annualPaymentAmountPence: number;
  member?: Member;
  paymentDetails: PaymentDetails;
  supportedPaymentKinds: string[];
  config?: { buttonText: string };
  cardTypes: string[];
  buttonClass?: string;
  priceSymbol?: string;
  paymentSelection?: string;
  footerText?: string;
  loqateApiKey?: string;
  useLoqateValidation?: boolean;
  useIBANBIC?: boolean;
  paymentErrorMessage?: string;
  ddMonth?: string;
  ddYear?: string;
  ddType?: string;
  updatePaymentDetails(mutate: (pd: PaymentDetails) => void): void;
  updateProcessingDisplay(processingMessage?: string): void;
  submit(): void;
  updatepaymentErrorDetail(errorMessage: string, ddMonth: string, ddYear: string): void;

}

interface State {
  activePaymentTab: PaymentTabs;
}

class MembershipSignupPayment extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      activePaymentTab: PaymentTabs.DirectDebit,
    };
  }

  updateDirectDebitDetails = (
    mutate: (dd: IDebitCardDetails) => void
  ): void => {
    let wrapper = (pd: PaymentDetails) => {
      if (pd.kind !== 'directdebit') {
        throw new Error('');
      }
      mutate(pd);
    };

    this.props.updatePaymentDetails(wrapper);
  };

  updateBankDetails = (
    mutate: (dd: IbanPaymentDetails) => void
  ): void => {
    let wrapper = (pd: PaymentDetails) => {
      if (pd.kind !== 'bankaccount') {
        throw new Error('');
      }
      mutate(pd);
    };
    this.props.updatePaymentDetails(wrapper);
  };

  updateCreditCardDetails = (
    mutate: (dd: CardPaymentDetails) => void
  ): void => {
    let wrapper = (ipd: PaymentDetails) => {
      if (ipd.kind !== 'creditcard') {
        throw new Error('');
      }

      mutate(ipd);
    };

    this.props.updatePaymentDetails(wrapper);
  };

  renderTabContent() {
    switch (this.props.paymentDetails.kind) {
      case 'directdebit':
        return (
          <DirectDebitPaymentForm
            config={{
              originatorsId: '297842',
              paymentAppearsAs: 'XXXXXXXX',
              ...this.props.config
            }}
            directDebitDetails={this.props.paymentDetails}
            updateDirectDebitDetails={this.updateDirectDebitDetails}
            annualPaymentAmountPence={this.props.annualPaymentAmountPence}
            submit={() => this.props.submit()}
            member={this.props.member}
            buttonClass={this.props.buttonClass}
            priceSymbol={this.props.priceSymbol}
            loqateApiKey={this.props.loqateApiKey}
            useLoqateValidation={this.props.useLoqateValidation}
            updateProcessingDisplay={this.props.updateProcessingDisplay}
            footerText={this.props.footerText}
            paymentErrorMessage={this.props.paymentErrorMessage}
            ddMonth={this.props.ddMonth}
            ddYear={this.props.ddYear}
            updatepaymentErrorDetail={this.props.updatepaymentErrorDetail}
            ddType={this.props.ddType}
          />
        );
      case 'creditcard':
        return (
          <CreditCardPaymentForm
            annualPaymentAmountPence={this.props.annualPaymentAmountPence}
            creditCardDetails={this.props.paymentDetails}

            buttonClass={this.props.buttonClass}
            priceSymbol={this.props.priceSymbol}
            cardTypes={this.props.cardTypes}
            paymentSelection={this.props.paymentSelection}
            updateCreditCardDetails={this.updateCreditCardDetails}
            submit={() => this.props.submit()}
          />
        );
      case 'bankaccount':
        return (
          <IbanPaymentForm
            config={{
              originatorsId: '297842',
              paymentAppearsAs: 'XXXXXXXX',
              ...this.props.config
            }}
            annualPaymentAmountPence={this.props.annualPaymentAmountPence}
            bankPaymentDetails={this.props.paymentDetails}
            member={this.props.member}
            buttonClass={this.props.buttonClass}
            priceSymbol={this.props.priceSymbol}
            loqateApiKey={this.props.loqateApiKey}
            useLoqateValidation={this.props.useLoqateValidation}
            updateBankDetails={this.updateBankDetails}
            updateProcessingDisplay={this.props.updateProcessingDisplay}
            submit={() => this.props.submit()}
            footerText={this.props.footerText}                              
            paymentErrorMessage={this.props.paymentErrorMessage}
            ddMonth={this.props.ddMonth}
            ddYear={this.props.ddYear}
            ddType={this.props.ddType}
            updatepaymentErrorDetail={this.props.updatepaymentErrorDetail}

          />
        );
      default:
        const _compileErrorIfPaymentTypeIsUnhandled: never = this.props.paymentDetails;
        throw 'Tab does not have content';
    }
  }

  render() {
    return (
      <div id="membership-signup-payment">
        {this.renderRadio()}
        <Row>
          <div id="membership-signup-payment-body" style={{ paddingTop: '10px' }}>
            {this.renderTabContent()}
          </div>
        </Row>
      </div>
    );
  }

  renderRadio() {
    if (this.props.supportedPaymentKinds.length > 1) {
      return (
        <>
          {this.isSupported('directdebit') && (this.props.useIBANBIC === false) && (
            <Radio
              id="payby-dd"
              group="payby"
              label="DirectDebit"
              defaultChecked={this.props.paymentDetails.kind === 'directdebit'}
              onChange={chkd => {
                if (chkd) {
                  this.props.updatePaymentDetails(pd => {
                    for (var k in DefaultIDebitCardDetails) {
                      if (DefaultIDebitCardDetails.hasOwnProperty(k)) {
                        pd[k] = DefaultIDebitCardDetails[k];
                      }
                    }
                  });
                }
              }}
            />
          )}
          {this.isSupported('creditcard') && (
            <Radio
              id="payby-cc"
              group="payby"
              label="Credit Card"
              defaultChecked={this.props.paymentDetails.kind === 'creditcard'}
              onChange={chkd => {
                if (chkd) {
                  this.props.updatePaymentDetails(pd => {
                    for (var k in DefaultCreditCardPaymentDetails) {
                      if (DefaultCreditCardPaymentDetails.hasOwnProperty(k)) {
                        pd[k] = DefaultCreditCardPaymentDetails[k];
                      }
                    }
                  });
                }
              }}
            />
          )}
          {this.isSupported('bankaccount') && (this.props.useIBANBIC) && (
            <Radio
              id="payby-ba"
              group="payby"
              label="Bank Account"
              defaultChecked={this.props.paymentDetails.kind === 'bankaccount'}
              onChange={chkd => {
                if (chkd) {
                  this.props.updatePaymentDetails(pd => {
                    for (var k in DefaultIbanBankAccountDetails) {
                      if (DefaultIbanBankAccountDetails.hasOwnProperty(k)) {
                        pd[k] = DefaultIbanBankAccountDetails[k];
                      }
                    }
                  });
                }
              }}
            />
          )}
        </>
      );
    }

    return;
  }

  private isSupported = (kind: string): boolean => {
    return this.props.supportedPaymentKinds.indexOf(kind) !== -1;
  };
}

export default MembershipSignupPayment;
export { PaymentDetails };



// WEBPACK FOOTER //
// ./src/MakeDonation/SignupJourney/Payment.tsx